import { getAuth } from 'firebase/auth';

export function signOut(): Promise<void> {
  const auth = getAuth();

  return auth.signOut();
}
